const capitalize = (str) => str[0].toUpperCase() + str.slice(1)

const humanize = (str) => str.replace(/[_-]/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())

export { capitalize, humanize }
